export enum ScormBehaviourType {
  NO_LIMITATIONS = 'no_limitations',
  WARN_NOT_COMPLETED = 'warn_not_completed',
  BLOCK_UNTIL_COMPLETED = 'block_until_completed',
  HIDE_UNTIL_COMPLETED = 'hide_until_completed'
}
